



// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';

// const InvoiceDetail = () => {
//   const { order_id } = useParams();
//   const [invoice, setInvoice] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (order_id) {
//       fetchInvoiceDetails();
//     }
//   }, [order_id]);

//   const fetchInvoiceDetails = async () => {
//     try {
//       setLoading(true);

//       const response = await fetch(
//         'https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_invoice_by_id',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             order_id: order_id
//           })
//         }
//       );

//       const result = await response.json();

//       if (result.status === 'true' && result.data) {
//         setInvoice(result.data);
//         setError(null);
//       } else {
//         setError(result.message || 'Failed to fetch invoice details');
//       }
//     } catch (err) {
//       setError('Failed to fetch invoice details');
//       console.error('Error fetching invoice:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return date.toLocaleDateString('en-US', options);
//   };

//   const getStatusBadge = (status) => {
//     const statusLower = status?.toLowerCase() || '';
//     if (statusLower === 'paid') {
//       return 'badge bg-success text-white px-2 py-1 fs-13';
//     } else if (statusLower === 'unpaid') {
//       return 'badge bg-danger text-white px-2 py-1 fs-13';
//     } else if (statusLower === 'partial') {
//       return 'badge bg-warning text-dark px-2 py-1 fs-13';
//     }
//     return 'badge bg-secondary text-white px-2 py-1 fs-13';
//   };

//   if (loading) {
//     return (
//       <div className="page-content">
//         <div className="container-fluid">
//           <div className="text-center p-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="page-content">
//         <div className="container-fluid">
//           <div className="alert alert-danger m-3" role="alert">
//             {error}
//           </div>
//           <Link to="/order-list" className="btn btn-primary">
//             Back to Orders
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   if (!invoice) {
//     return (
//       <div className="page-content">
//         <div className="container-fluid">
//           <div className="alert alert-warning m-3" role="alert">
//             No invoice data found
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="page-content">
//       {/* Start Container Fluid */}
//       <div className="container-fluid">
//         {/* ========== Page Title Start ========== */}
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box">
//               <h4 className="mb-0 fw-semibold">Invoice Details</h4>
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-item">
//                   <Link to="/order-list">Invoice</Link>
//                 </li>
//                 <li className="breadcrumb-item active">Invoice Details</li>
//               </ol>
//             </div>
//           </div>
//         </div>
//         {/* ========== Page Title End ========== */}
        
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             <div className="card">
//               <div className="card-body">
//                 {/* Logo & title */}
//                 <div className="clearfix pb-3 bg-info-subtle p-lg-3 p-2 m-n2 rounded position-relative">
//                   <div className="float-sm-start">
//                     <div className="auth-logo">
//                       <img
//                         className="logo-dark me-1"
//                         src="/images/logo-dark.png"
//                         alt="logo-dark"
//                         height={24}
//                       />
//                     </div>
//                     <div className="mt-4">
//                       <h4>{invoice.sender_name}</h4>
//                       <address className="mt-3 mb-0">
//                         {invoice.sender_address}
//                         <br />
//                         <abbr title="Phone">Phone:</abbr> {invoice.sender_number}
//                       </address>
//                     </div>
//                   </div>
//                   <div className="float-sm-end">
//                     <div className="table-responsive">
//                       <table className="table table-borderless mb-0">
//                         <tbody>
//                           <tr>
//                             <td className="p-0 pe-5 py-1">
//                               <p className="mb-0 text-dark fw-semibold">Invoice :</p>
//                             </td>
//                             <td className="text-end text-dark fw-semibold px-0 py-1">
//                               {invoice.invoice_no}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="p-0 pe-5 py-1">
//                               <p className="mb-0">Issue Date: </p>
//                             </td>
//                             <td className="text-end text-dark fw-medium px-0 py-1">
//                               {formatDate(invoice.issue_date)}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="p-0 pe-5 py-1">
//                               <p className="mb-0">Due Date : </p>
//                             </td>
//                             <td className="text-end text-dark fw-medium px-0 py-1">
//                               {formatDate(invoice.due_date)}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="p-0 pe-5 py-1">
//                               <p className="mb-0">Amount : </p>
//                             </td>
//                             <td className="text-end text-dark fw-medium px-0 py-1">
//                               ₹{parseFloat(invoice.grand_total).toFixed(2)}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="p-0 pe-5 py-1">
//                               <p className="mb-0">Status : </p>
//                             </td>
//                             <td className="text-end px-0 py-1">
//                               <span className={getStatusBadge(invoice.status)}>
//                                 {invoice.status}
//                               </span>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   <div className="position-absolute top-100 start-50 translate-middle">
//                     <img
//                       src="/images/check-2.png"
//                       alt=""
//                       className="img-fluid"
//                     />
//                   </div>
//                 </div>

//                 <div className="clearfix pb-3 mt-4">
//                   <div className="float-sm-start">
//                     <div className="">
//                       <h4 className="card-title">Issue From :</h4>
//                       <div className="mt-3">
//                         <h4>{invoice.issuer_from}</h4>
//                         <p className="mb-2">{invoice.issuer_address}</p>
//                         <p className="mb-2">
//                           <span className="text-decoration-underline">Phone :</span>{' '}
//                           {invoice.issuer_number}
//                         </p>
//                         <p className="mb-2">
//                           <span className="text-decoration-underline">Email :</span>{' '}
//                           {invoice.issuer_email}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="float-sm-end">
//                     <div className="">
//                       <h4 className="card-title">Issue For :</h4>
//                       <div className="mt-3">
//                         <h4>{invoice.buyer_from}</h4>
//                         <p className="mb-2">{invoice.buyer_address}</p>
//                         <p className="mb-2">
//                           <span className="text-decoration-underline">Phone :</span>{' '}
//                           {invoice.buyer_number}
//                         </p>
//                         <p className="mb-2">
//                           <span className="text-decoration-underline">Email :</span>{' '}
//                           {invoice.buyer_email}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-12">
//                     <div className="table-responsive table-borderless text-nowrap table-centered">
//                       <table className="table mb-0">
//                         <thead className="bg-light bg-opacity-50">
//                           <tr>
//                             <th className="border-0 py-2">Product Name</th>
//                             <th className="border-0 py-2">Quantity</th>
//                             <th className="border-0 py-2">Price</th>
//                             <th className="border-0 py-2">Tax</th>
//                             <th className="text-end border-0 py-2">Total</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {invoice.product_items && invoice.product_items.length > 0 ? (
//                             invoice.product_items.map((item, index) => (
//                               <tr key={index}>
//                                 <td>
//                                   <div className="d-flex align-items-center gap-3">
//                                     {invoice.product_image && index === 0 && (
//                                       <div className="rounded bg-light avatar d-flex align-items-center justify-content-center">
//                                         <img
//                                           src={`https://cyberathon.com/multivendor/uploads/${invoice.product_image}`}
//                                           alt="Product"
//                                           className="avatar"
//                                           onError={(e) => {
//                                             e.target.src = '/images/product/p-1.png';
//                                           }}
//                                         />
//                                       </div>
//                                     )}
//                                     <div>
//                                       <a href="#!" className="text-dark fw-medium fs-15">
//                                         {item.product_name}
//                                       </a>
//                                       <p className="text-muted mb-0 mt-1 fs-13">
//                                         <span>Size :</span> {item.size}
//                                       </p>
//                                     </div>
//                                   </div>
//                                 </td>
//                                 <td>{item.qty}</td>
//                                 <td>₹{parseFloat(item.price).toFixed(2)}</td>
//                                 <td>₹{parseFloat(item.tax).toFixed(2)}</td>
//                                 <td className="text-end">₹{parseFloat(item.total).toFixed(2)}</td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="5" className="text-center py-3">
//                                 No product items found
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row justify-content-end">
//                   <div className="col-lg-5 col-6">
//                     <div className="table-responsive">
//                       <table className="table table-borderless mb-0">
//                         <tbody>
//                           <tr className="">
//                             <td className="text-end p-0 pe-5 py-2">
//                               <p className="mb-0"> Sub Total : </p>
//                             </td>
//                             <td className="text-end text-dark fw-medium py-2">
//                               ₹{parseFloat(invoice.sub_total).toFixed(2)}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="text-end p-0 pe-5 py-2">
//                               <p className="mb-0">Discount : </p>
//                             </td>
//                             <td className="text-end text-dark fw-medium py-2">
//                               -₹{parseFloat(invoice.discount).toFixed(2)}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="text-end p-0 pe-5 py-2">
//                               <p className="mb-0">Estimated Tax : </p>
//                             </td>
//                             <td className="text-end text-dark fw-medium py-2">
//                               ₹{parseFloat(invoice.estimated_tax).toFixed(2)}
//                             </td>
//                           </tr>
//                           <tr className="border-top">
//                             <td className="text-end p-0 pe-5 py-2">
//                               <p className="mb-0 text-dark fw-semibold">Grand Amount :</p>
//                             </td>
//                             <td className="text-end text-dark fw-semibold py-2">
//                               ₹{parseFloat(invoice.grand_total).toFixed(2)}
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-lg-12">
//                     <div className="alert alert-danger alert-icon p-2" role="alert">
//                       <div className="d-flex align-items-center">
//                         <div className="avatar-sm rounded bg-danger d-flex justify-content-center align-items-center fs-18 me-2 flex-shrink-0">
//                           <i className="bx bx-info-circle text-white" />
//                         </div>
//                         <div className="flex-grow-1">
//                           All accounts are to be paid within 7 days from receipt of
//                           invoice. To be paid by cheque or credit card or direct
//                           payment online. If account is not paid within 7 days the
//                           credits details supplied as confirmation of work
//                           undertaken will be charged the agreed quoted fee noted
//                           above.
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mt-3 mb-1">
//                   <div className="text-end d-print-none">
//                     <a
//                       href="javascript:window.print()"
//                       className="btn btn-info width-xl"
//                     >
//                       Print
//                     </a>
//                     <Link
//                       to="/order-list"
//                       className="btn btn-outline-primary width-xl"
//                     >
//                       Back to Orders
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* End Container Fluid */}

//       {/* ========== Footer Start ========== */}
//       <footer className="footer">
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-12 text-center">
//               © Venton. Crafted by{" "}
//               <iconify-icon
//                 icon="iconamoon:heart-duotone"
//                 className="fs-18 align-middle text-danger"
//               />{" "}
//               <a href="" className="fw-bold footer-text" target="_blank">
//                 Techzaa
//               </a>
//             </div>
//           </div>
//         </div>
//       </footer>
//       {/* ========== Footer End ========== */}
//     </div>
//   );
// };

// export default InvoiceDetail;



import React, { useState, useEffect } from 'react';

const InvoiceDetailPopup = ({ show, onClose, orderId }) => {
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show && orderId) {
      fetchInvoiceDetails();
    }
  }, [show, orderId]);

  const fetchInvoiceDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        'https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_invoice_by_id',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            order_id: orderId
          })
        }
      );

      const result = await response.json();

      if (result.status === 'true' && result.data) {
        setInvoice(result.data);
      } else {
        setError(result.message || 'Failed to fetch invoice details');
      }
    } catch (err) {
      setError('Failed to fetch invoice details');
      console.error('Error fetching invoice:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const getStatusBadge = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower === 'paid') {
      return 'badge bg-success text-white px-2 py-1 fs-13';
    } else if (statusLower === 'unpaid') {
      return 'badge bg-danger text-white px-2 py-1 fs-13';
    } else if (statusLower === 'partial') {
      return 'badge bg-warning text-dark px-2 py-1 fs-13';
    }
    return 'badge bg-secondary text-white px-2 py-1 fs-13';
  };

  const handlePrint = () => {
    const printContent = document.getElementById('invoice-print-content');
    const printWindow = window.open('', '_blank');
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Invoice ${invoice?.invoice_no || ''}</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { padding: 20px; }
            @media print {
              .no-print { display: none !important; }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              }
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-semibold">Invoice Details</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {loading ? (
              <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            ) : invoice ? (
              <div id="invoice-print-content">
                {/* Logo & title */}
                <div className="clearfix pb-3 bg-info-subtle p-lg-3 p-2 rounded position-relative mb-4">
                  <div className="float-sm-start">
                    <div className="auth-logo">
                      <img
                        className="logo-dark me-1"
                        src="/images/logo-dark.png"
                        alt="logo-dark"
                        height={24}
                      />
                    </div>
                    <div className="mt-4">
                      <h4>{invoice.sender_name}</h4>
                      <address className="mt-3 mb-0">
                        {invoice.sender_address}
                        <br />
                        <abbr title="Phone">Phone:</abbr> {invoice.sender_number}
                      </address>
                    </div>
                  </div>
                  <div className="float-sm-end">
                    <div className="table-responsive">
                      <table className="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td className="p-0 pe-5 py-1">
                              <p className="mb-0 text-dark fw-semibold">Invoice :</p>
                            </td>
                            <td className="text-end text-dark fw-semibold px-0 py-1">
                              {invoice.invoice_no}
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 pe-5 py-1">
                              <p className="mb-0">Issue Date: </p>
                            </td>
                            <td className="text-end text-dark fw-medium px-0 py-1">
                              {formatDate(invoice.issue_date)}
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 pe-5 py-1">
                              <p className="mb-0">Due Date : </p>
                            </td>
                            <td className="text-end text-dark fw-medium px-0 py-1">
                              {formatDate(invoice.due_date)}
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 pe-5 py-1">
                              <p className="mb-0">Amount : </p>
                            </td>
                            <td className="text-end text-dark fw-medium px-0 py-1">
                              ₹{parseFloat(invoice.grand_total).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 pe-5 py-1">
                              <p className="mb-0">Status : </p>
                            </td>
                            <td className="text-end px-0 py-1">
                              <span className={getStatusBadge(invoice.status)}>
                                {invoice.status}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="position-absolute top-100 start-50 translate-middle">
                    <img
                      src="/images/check-2.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>

                {/* Issue From & For */}
                <div className="clearfix pb-3 mb-4">
                  <div className="float-sm-start">
                    <h5 className="card-title">Issue From :</h5>
                    <div className="mt-3">
                      <h5>{invoice.issuer_from}</h5>
                      <p className="mb-2">{invoice.issuer_address}</p>
                      <p className="mb-2">
                        <span className="text-decoration-underline">Phone :</span>{' '}
                        {invoice.issuer_number}
                      </p>
                      <p className="mb-2">
                        <span className="text-decoration-underline">Email :</span>{' '}
                        {invoice.issuer_email}
                      </p>
                    </div>
                  </div>
                  <div className="float-sm-end">
                    <h5 className="card-title">Issue For :</h5>
                    <div className="mt-3">
                      <h5>{invoice.buyer_from}</h5>
                      <p className="mb-2">{invoice.buyer_address}</p>
                      <p className="mb-2">
                        <span className="text-decoration-underline">Phone :</span>{' '}
                        {invoice.buyer_number}
                      </p>
                      <p className="mb-2">
                        <span className="text-decoration-underline">Email :</span>{' '}
                        {invoice.buyer_email}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Products Table */}
                <div className="table-responsive table-borderless text-nowrap table-centered mb-4">
                  <table className="table mb-0">
                    <thead className="bg-light bg-opacity-50">
                      <tr>
                        <th className="border-0 py-2">Product Name</th>
                        <th className="border-0 py-2">Quantity</th>
                        <th className="border-0 py-2">Price</th>
                        <th className="border-0 py-2">Tax</th>
                        <th className="text-end border-0 py-2">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoice.product_items && invoice.product_items.length > 0 ? (
                        invoice.product_items.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div className="d-flex align-items-center gap-3">
                                {invoice.product_image && index === 0 && (
                                  <div className="rounded bg-light avatar d-flex align-items-center justify-content-center">
                                    <img
                                      src={`https://cyberathon.com/multivendor/uploads/${invoice.product_image}`}
                                      alt="Product"
                                      className="avatar"
                                      onError={(e) => {
                                        e.target.src = '/images/product/p-1.png';
                                      }}
                                    />
                                  </div>
                                )}
                                <div>
                                  <a href="#!" className="text-dark fw-medium fs-15">
                                    {item.product_name}
                                  </a>
                                  <p className="text-muted mb-0 mt-1 fs-13">
                                    <span>Size :</span> {item.size}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td>{item.qty}</td>
                            <td>₹{parseFloat(item.price).toFixed(2)}</td>
                            <td>₹{parseFloat(item.tax).toFixed(2)}</td>
                            <td className="text-end">₹{parseFloat(item.total).toFixed(2)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-3">
                            No product items found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Summary */}
                <div className="row justify-content-end mb-4">
                  <div className="col-lg-5 col-md-6">
                    <div className="table-responsive">
                      <table className="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td className="text-end p-0 pe-5 py-2">
                              <p className="mb-0">Sub Total :</p>
                            </td>
                            <td className="text-end text-dark fw-medium py-2">
                              ₹{parseFloat(invoice.sub_total).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end p-0 pe-5 py-2">
                              <p className="mb-0">Discount :</p>
                            </td>
                            <td className="text-end text-dark fw-medium py-2">
                              -₹{parseFloat(invoice.discount).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end p-0 pe-5 py-2">
                              <p className="mb-0">Estimated Tax :</p>
                            </td>
                            <td className="text-end text-dark fw-medium py-2">
                              ₹{parseFloat(invoice.estimated_tax).toFixed(2)}
                            </td>
                          </tr>
                          <tr className="border-top">
                            <td className="text-end p-0 pe-5 py-2">
                              <p className="mb-0 text-dark fw-semibold">Grand Amount :</p>
                            </td>
                            <td className="text-end text-dark fw-semibold py-2">
                              ₹{parseFloat(invoice.grand_total).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Alert */}
                <div className="alert alert-danger alert-icon p-2" role="alert">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm rounded bg-danger d-flex justify-content-center align-items-center fs-18 me-2 flex-shrink-0">
                      <i className="bx bx-info-circle text-white" />
                    </div>
                    <div className="flex-grow-1">
                      All accounts are to be paid within 7 days from receipt of
                      invoice. To be paid by cheque or credit card or direct
                      payment online. If account is not paid within 7 days the
                      credits details supplied as confirmation of work
                      undertaken will be charged the agreed quoted fee noted above.
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="alert alert-warning" role="alert">
                No invoice data found
              </div>
            )}
          </div>

          <div className="modal-footer bg-light">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            {invoice && (
              <button
                type="button"
                className="btn btn-info"
                onClick={handlePrint}
              >
                <i className="fa-solid fa-print me-1"></i> Print Invoice
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetailPopup;